<template>
  <NCollapseItem v-bind="attrs" class="c-collapse-item">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </NCollapseItem>
</template>

<script lang="ts" setup>
import type { CollapseItemProps } from 'naive-ui'
import { NCollapseItem } from 'naive-ui'
import { useAttrs } from 'vue'

const attrs: CollapseItemProps = useAttrs()

defineSlots()
</script>
